const CND = x => {
  if (x < 0) {
    return 1 - CND(-x);
  } else {
    const k = 1 / (1 + 0.2316419 * x);
    return (
      1 -
      (Math.exp((-x * x) / 2) / Math.sqrt(2 * Math.PI)) *
        k *
        (0.31938153 + k * (-0.356563782 + k * (1.781477937 + k * (-1.821255978 + k * 1.330274429))))
    );
  }
};

/** Prob ITM: P(S_t >= X) for calls, P(S_t <= X) for puts
 *
 * @param {String} typeFlag (C || P)
 * @param {String} S stock price
 * @param {String} X strike price
 * @param {String} Time time to expiration (in years)
 * @param {String} r risk-free rate
 * @param {String} r_d dividend yield
 * @param {String} sigma volatility
 *
 * @return {Number} result
 */
function ProbITM(typeFlag, S, X, Time, r, r_d, sigma) {
  //console.log(typeFlag + ', ' + S + ', ' + X + ', ' + Time + ', ' + r + ', ' + r_d + ', ' + sigma);
  let result;

  if (typeFlag === 'C') {
    // P(S_t >= X)
    result =
      1 - CND((Math.log(X / S) - (r - r_d - Math.pow(sigma, 2) / 2) * Time) / Math.sqrt(Math.pow(sigma, 2) * Time));
  } else if (typeFlag === 'P') {
    // P(S_t <= X)
    result = CND((Math.log(X / S) - (r - r_d - Math.pow(sigma, 2) / 2) * Time) / Math.sqrt(Math.pow(sigma, 2) * Time));
  }
  return result;
}

/** Prob OTM: Out-of-the-Money Probability: P(S_t <= X) for calls, P(S_t >= X) for puts
 *
 * @param {String} typeFlag (C || P)
 * @param {String} S stock price
 * @param {String} X strike price
 * @param {String} Time time to expiration (in years)
 * @param {String} r risk-free rate
 * @param {String} r_d dividend yield
 * @param {String} sigma volatility
 *
 * @return {} result
 */
function ProbOTM(typeFlag, S, X, Time, r, r_d, sigma) {
  let result;
  if (typeFlag === 'C') {
    // P(S_t <= X)
    result = CND((Math.log(X / S) - (r - r_d - Math.pow(sigma, 2) / 2) * Time) / Math.sqrt(Math.pow(sigma, 2) * Time));
  } else if (typeFlag === 'P') {
    // P(S_t >= X)
    result =
      1 - CND((Math.log(X / S) - (r - r_d - Math.pow(sigma, 2) / 2) * Time) / Math.sqrt(Math.pow(sigma, 2) * Time));
  }
  return result;
}

/** Prob Touch: probability to touch level X until maturity Time. Should be the same for call and puts...
 *
 * @param {String} typeFlag (C || P)
 * @param {String} S stock price
 * @param {String} X strike price
 * @param {String} Time time to expiration (in years)
 * @param {String} r risk-free rate
 * @param {String} r_d dividend yield
 * @param {String} sigma volatility
 *
 * @return {} result
 */
function ProbTouch(typeFlag, S, X, Time, r, r_d, sigma) {
  let result;
  if (S < X) {
    // S < X: Prob Touch = Maximum des Prozesses erreicht X
    // P(M_t >= X)")
    const drift = r - r_d - Math.pow(sigma, 2) / 2;
    const y = Math.log(X / S);
    result =
      1 -
      CND((y - drift * Time) / (sigma * Math.sqrt(Time))) +
      Math.exp((2 * drift * y) / Math.pow(sigma, 2)) * CND((-y - drift * Time) / (sigma * Math.sqrt(Time)));
  } else if (S > X) {
    // S > X: Prob Touch = Minimum des Prozesses erreicht X
    // P(m_t <= X)")
    const drift = r - r_d - Math.pow(sigma, 2) / 2;
    const y = Math.log(X / S);
    result =
      CND((y - drift * Time) / (sigma * Math.sqrt(Time))) +
      Math.exp((2 * drift * y) / Math.pow(sigma, 2)) * CND((y + drift * Time) / (sigma * Math.sqrt(Time)));
  } else if (S == X) {
    result = 1;
  }
  return result;
}

export const probabilityCalculations = {
  ProbITM,
  ProbOTM,
  ProbTouch
};
